import React from 'react';
import { Section } from './Section';
import { useLanguage } from './LanguageContext';
export function Experience() {
  const {
    t
  } = useLanguage();
  return <Section className="bg-barber-dark border-y border-barber-lightGray" data-id="element-156">
      <div className="max-w-3xl mx-auto text-center" data-id="element-157">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-barber-text uppercase mb-12" data-id="element-158">
          {t('experience.heading1')} <br data-id="element-159" />
          <span className="text-barber-gold" data-id="element-160">{t('experience.heading2')}</span>
        </h2>
        <div className="space-y-8 text-lg md:text-xl text-barber-muted" data-id="element-161">
          <p data-id="element-162">{t('experience.line1')}</p>
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 py-6 font-heading text-2xl uppercase tracking-wider text-barber-text" data-id="element-163">
            <span className="opacity-50 line-through decoration-barber-red decoration-2" data-id="element-164">
              {t('experience.noChaos')}
            </span>
            <span className="hidden md:block text-barber-lightGray" data-id="element-165">•</span>
            <span className="opacity-50 line-through decoration-barber-red decoration-2" data-id="element-166">
              {t('experience.noYelling')}
            </span>
            <span className="hidden md:block text-barber-lightGray" data-id="element-167">•</span>
            <span className="opacity-50 line-through decoration-barber-red decoration-2" data-id="element-168">
              {t('experience.noMess')}
            </span>
          </div>
          <p className="text-3xl font-heading font-bold text-barber-gold uppercase tracking-widest py-4" data-id="element-169">
            {t('experience.prof')}
          </p>
          <p data-id="element-170">{t('experience.line2')}</p>
          <p className="pt-8" data-id="element-171">{t('experience.line3')}</p>
          <p className="text-4xl md:text-5xl font-heading font-bold text-barber-text uppercase tracking-widest py-4" data-id="element-172">
            {t('experience.trust')}
          </p>
          <p data-id="element-173">{t('experience.line4')}</p>
        </div>
      </div>
    </Section>;
}